export * from './src/bookings-staff-settings-v1-staff-member-settings-staff-member-settings.meta.js';
